module.exports = __webpack_public_path__ + "img/mollusques.51d541e6.svg";